import * as React from "react";
import { useForm, FormProvider, UseFormProps } from "react-hook-form";
import { DatasourcesContextProvider, IDatasource } from "@generation/core";
import { FormButtons } from "../Interfaces/FormProps";

export interface IWithFormProps {
  datasources?: IDatasource[];
  formOptions?: UseFormProps;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
}

export function withForm<T extends IWithFormProps>(Component: React.FunctionComponent<T>) {
  const component = (props: T) => {
    const form = useForm(props.formOptions);

    return (
      <DatasourcesContextProvider datasources={props.datasources ?? []}>
        <FormProvider {...form}>
          <Component {...props} />
        </FormProvider>
      </DatasourcesContextProvider>
    );
  };

  component.displayName = "WithForm";

  return component;
}
